import React, { useState } from 'react'
import PropTypes from 'prop-types'
import {
  BrowserRouter as Router,
  Redirect,
  Route,
  Switch
} from 'react-router-dom'
import { compose, withApollo } from 'react-apollo'

import Login from './Login'
import Signup from './Signup'
import SignupBin from './SignupBin'
import Document from './Document'
import Location from './Location'
import Hero from './Hero'
import BinLogin from './BinLogin'
import Product from './Product'
import ForgotPassword from './ForgotPassword'
import ResetPassword from './ResetPassword'
import CheckEmail from './CheckEmail'
import VerifyEmail from './VerifyEmail'
import UpdateEmail from './UpdateEmail'
import Account from './Account'
import Profile from './Profile'
import ChangePassword from './ChangePassword'
import Sidebar from '../components/Sidebar'
import HeroLocations from './HeroLocations'
import StartPage from './StartPage'
import AccountProduct from './AccountProduct'
import AccountLocation from './AccountLocation'
import AccountDocument from './AccountDocument'
import Context from '../context'
import HeroSetting from './HeroSetting'
import AccountBin from './AccountBin'
import AccountProfileBin from './AccountProfileBin'
import AccountLocationBin from './AccountLocationBin'
import AccountFactory from './AccountFactory'
import FactoryAnnouncement from './FactoryAnnouncement'
import Reports from './Reports'
import MyQrCode from './MyQrCode'
// import { Centered } from '../shared.style'
// import { Spin } from 'antd'
import { useDispatch, useSelector } from 'react-redux'
import { useDeepEffect } from '../utils/hooks'
import { getHeroConfigs, getHeroMe, removeStoreHero } from '../stores/hero'
import { logout } from '../stores/auth'
import { fetchHeroNewsItem } from '../stores/heroNewsItems'
import { isEmpty } from 'lodash'

const init = {
  panel: false,
  tabIndex: 0,
  uploading: false
}

export const App = (props) => {
  const { client } = props
  const [drawerOpen, setDrawerOpen] = useState(false)
  const [state, setState] = useState(init)
  const dispatch = useDispatch()

  const { isAuthenticate } = useSelector((state) => state.auth)
  const { me, heroConfigList } = useSelector((state) => state.hero)

  useDeepEffect(() => {
    async function fetchData() {
      await dispatch(getHeroMe())
      await dispatch(getHeroConfigs())
      await dispatch(fetchHeroNewsItem())
    }

    if (isAuthenticate) {
      fetchData()
    }
  }, [isAuthenticate])

  const closeDrawer = () => {
    setDrawerOpen(!drawerOpen)
  }

  const onLogout = () => {
    client.resetStore()
    dispatch(logout())
    dispatch(removeStoreHero())
  }

  return (
    <Context.Provider value={{ state, setState }}>
      <Router>
        {!isEmpty(me) ? (
          <React.Fragment>
            <Sidebar
              open={drawerOpen}
              ToggleDrawer={closeDrawer}
              user={me}
              logout={onLogout}
            />
            <Switch>
              {/* <Route */}
              {/*  exact */}
              {/*  path="/" */}
              {/*  component={() => ( */}
              {/*    <Account */}
              {/*      ToggleDrawer={closeDrawer} */}
              {/*      me={data.me} */}
              {/*      heroConfig={data.heroConfigs.find( */}
              {/*      config => config.heroType === data.me.heroType */}
              {/*    )} */}
              {/*      Logout={logout} */}
              {/*    /> */}
              {/*  )} */}
              {/* /> */}
              <Route
                exact
                path="/"
                component={() => (
                  <Account ToggleDrawer={closeDrawer} me={me} Logout={logout} />
                )}
              />
              <Route
                exact
                path="/account"
                component={() => (
                  <Account ToggleDrawer={closeDrawer} me={me} Logout={logout} />
                )}
              />
              <Route
                exact
                path="/hero/setting"
                component={() => (
                  <HeroSetting ToggleDrawer={closeDrawer} me={me} />
                )}
              />
              <Route
                exact
                path="/account/profile"
                component={() => <Profile me={me} />}
              />
              <Route
                exact
                path="/account/bin/profile"
                component={() => <AccountProfileBin me={me} />}
              />
              <Route
                exact
                path="/account/bin/locations"
                component={() => <AccountLocationBin me={me} />}
              />
              <Route
                exact
                path="/account/products"
                component={() => <AccountProduct me={me} />}
              />
              <Route
                exact
                path="/account/factory"
                component={() => <AccountFactory me={me} />}
              />
              <Route
                exact
                path="/factory/announcement"
                component={() => <FactoryAnnouncement me={me} />}
              />
              <Route
                exact
                path="/account/locations"
                component={() => (
                  <AccountLocation me={me} heroConfigList={heroConfigList} />
                )}
              />
              <Route
                exact
                path="/account/documents"
                component={() => <AccountDocument me={me} />}
              />
              <Route
                exact
                path="/report"
                component={() => <Reports me={me} />}
              />
              <Route
                exact
                path="/my-qr-code"
                component={() => <MyQrCode me={me} />}
              />
              <Route
                exact
                path="/account/bins"
                component={() => <AccountBin me={me} />}
              />
              {/* AccountDocument */}
              <Route
                exact
                path="/reset_password/:token"
                component={ResetPassword}
              />
              <Route
                exact
                path="/password"
                component={() => <ChangePassword me={me} />}
              />
              <Route exact path="/map" component={HeroLocations} />
              <Redirect from="*" to="/" />
            </Switch>
          </React.Fragment>
        ) : (
          <Switch>
            <Route exact path="/" component={StartPage} />
            <Route exact path="/login" component={Login} />
            <Route exact path="/signup/:heroType" component={Signup} />
            <Route exact path="/signup-bin" component={SignupBin} />
            <Route exact path="/forgot-password" component={ForgotPassword} />
            <Route exact path="/check-email" component={CheckEmail} />
            <Route exact path="/verifyEmail/:token" component={VerifyEmail} />
            <Route exact path="/verifyUpdateEmail/:token" component={UpdateEmail} />
            <Route
              exact
              path="/reset_password/:token"
              component={ResetPassword}
            />
            <Route exact path="/hero" component={Hero} />
            <Route exact path="/bin" component={BinLogin} />
            <Route exact path="/document" component={Document} />
            <Route
              exact
              path="/location"
              component={() => <Location me={me} />}
            />
            <Route path='/green2get' component={() => {
              window.location.href = 'https://green2get.com/';
              return null;
            }} />
            <Route
              exact
              path="/product"
              component={() => <Product me={me} />}
            />
            <Route exact path="/map" component={HeroLocations} />
            <Redirect from="*" to="/" />
          </Switch>
        )}
      </Router>
    </Context.Provider>
  )
}

App.propTypes = {
  client: PropTypes.object.isRequired
}

export default compose(withApollo)(App)



// WEBPACK FOOTER //
// ./src/pages/App.js